import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['submit' ]

  teamSelected(event) {
    const selectedOption = event.target.options[event.target.selectedIndex]

    if(selectedOption.value) {
      this.submitTarget.disabled = false
    } else {
      this.submitTarget.disabled = true
    }
  }
}
